'use client'
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface PopupAdvertProps {
  imageUrl: string;
  altText?: string;
  onClose?: () => void;
}

const PopupAdvert: React.FC<PopupAdvertProps> = ({ 
  imageUrl, 
  altText = "Advertisement", 
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup after a short delay when component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div className="relative max-w-4xl max-h-[90vh] mx-4 bg-white rounded-lg shadow-2xl overflow-hidden">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
          aria-label="Close advertisement"
        >
          <X className="w-6 h-6 text-gray-700" />
        </button>
        
        {/* Advertisement Image */}
        <div className="relative">
          <img
            src={imageUrl}
            alt={altText}
            className="w-full h-auto max-h-[80vh] object-contain"
            onError={(e) => {
              console.error('Failed to load advertisement image');
              // You could set a fallback image here
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PopupAdvert;
